export interface IdName {
  id: number;
  name: string;
}

export interface AvailableDomainsConfiguration {
  domainTypes: { [key: number]: string };
  domainPools: IdName[];
  availableDomains: { [key: number]: IdName[] };
}

export interface AvailableDomainsPoolsConfiguration {
  availableDomains: { DomainTypes: IdName[] };
  domainTypes: IdName[];
}

export enum DomainTypes {
  Shared = 1,
  Dedicated = 2,
}

export enum DomainStatus {
  Used = 1,
  Available = 2,
}

export interface AccountDomain {
  accountId: number;
  domainName: string;
  domainId: number;
}

export interface Domain {
  id: number;
  name: string;
  dateAdded: string;
  status: DomainStatus;
  type: DomainTypes;
  usedBy: IdName[];
}

export interface DomainApiResponse {
  id: number;
  domain?: string;
  name: string;
  dateAdded?: string;
  statusId?: number;
  status?: number;
  domainTypeId?: number;
  domainType?: number;
  usedByAccounts?: { id: number; name: string }[];
}

export interface DomainsResult {
  items: DomainApiResponse[];
  totalCount: number;
}
